module.exports = __webpack_public_path__ + "static/Luisa-Galindo-4e53df254e548eaca5def351eb227f9c.png";